import React from "react";
// import PropTypes from "prop-types";
import { useDispatch, useSelector } from "react-redux";
import { getThemeMode } from "../../state/theme/theme.selector";
import { changeThemeMode } from "../../state/theme/theme.action";
import "./ThemeSwitch.css";

const ThemeSwitch = (props) => {
  const themeMode = useSelector(getThemeMode);
  // const [ themeMode, setThemeMode] = useState(useSelector(getThemeMode));
  const dispatch = useDispatch();
  const handleThemeChange = (e) => {
    if (e.target.checked) {
      dispatch(changeThemeMode("light"));
    } else {
      dispatch(changeThemeMode("dark"));
    }
  };
  return (
    <label id="switch" className="switch">
      <input
        type="checkbox"
        id="slider"
        onChange={handleThemeChange}
        checked={themeMode === "light"}
      />
      <span className="slider round"></span>
    </label>
  );
};

ThemeSwitch.propTypes = {};

export default ThemeSwitch;
